import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fbb8728"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center-input-pages" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-text" }, "争芳后台", -1))
const _hoisted_3 = { class: "input-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-title" }, "使用微信扫码登录", -1))
const _hoisted_5 = { class: "qr-code-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "qr-code",
  id: "wechat-qr-code"
}, null, -1))
const _hoisted_7 = { class: "input-box" }
const _hoisted_8 = { class: "input-title" }
const _hoisted_9 = { class: "input-phone" }
const _hoisted_10 = { class: "input-code" }
const _hoisted_11 = {
  key: 1,
  class: "code-reset"
}

import { getCurrentInstance, onMounted, ref } from "vue";
import {
  getUserLoginSonAccountListApi,
  getUserPhoneCode,
  getWeChartConfigInfo,
  postWechatLoginByCode,
  userLoginGetInfo
} from "@/views/Login/_apis";
import { hex_md5 } from "@/utils/md5";
import { checkMobile, getUrlParams, removeWeChartUrlParams } from "@/utils";
import { useRouter } from "vue-router";
import { CSS_STYLE_BY_SCAN_QRCODE } from "@/views/Login/_data";
import SelectLoginSonAccountPopup from "@/views/Login/_components/SelectLoginSonAccountPopup/index.vue";
import { getJumpRoute } from "@/views/Login/_service";

/** 导入提示 */

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const Message =
  getCurrentInstance()?.appContext.config.globalProperties.$message;

/** 导航跳转 */
const Router = useRouter();
/** 默认登录方式 */
const defaultLoginType = ref<"qrcode" | "phone">("qrcode");
/** 是否绑定 */
const isBindStatus = ref<boolean>(false);
/** 是否已经获取了验证码 */
let isGetCodeStatus = ref<boolean>(false);
/** 重新获取验证码倒计时实例 */
let countdownResetCodeEl = ref<any>();
/** 手机号 */
const telephone = ref<string>();
/** 手机验证码 */
const telCode = ref<string>();
/** 重新获取验证码 */
const resetCodeTime = ref<number>(60);
/** 加载状态 */
const spinningStatus = ref(true);
/** 用户openId */
const openId = ref<string>("");
/** 用户unionId */
const unionId = ref<string>("");
/** 用户Token */
const accessToken = ref<string>("");
/** 用户省份 */
const province = ref<string>("");
/** 用户地区 */
const city = ref<string>("");
/** 需要绑定的状态 */
const needBindStatus = ref<string>("0");
/** 重定向地址 */
const redirectUrl = ref<string>("");
/** 是否需要多店铺选择登录 */
const chooseShopSelectStatus = ref<boolean>(false);
/** 子账号弹窗选择实例 */
const selectLoginSonAccountPopupEl = ref();

/** 二维码登录初始化 */
const qrCodeInit = async () => {
  spinningStatus.value = true;
  const res = await getWeChartConfigInfo();
  if (res.status !== "200") return;
  const configInfo = res.data;
  redirectUrl.value = configInfo.redirect_uri;
  new WxLogin({
    self_redirect: false,
    id: "wechat-qr-code",
    // appid: "wx2349bc768b04c2d9",
    appid: configInfo.appid,
    scope: configInfo.scope,
    // scope: "snsapi_login",
    redirect_uri: configInfo.redirect_uri,
    // redirect_uri: "https://zf.douquan.com",
    state: new Date().getTime(),
    style: "",
    href: CSS_STYLE_BY_SCAN_QRCODE
  });
  setTimeout(() => {
    spinningStatus.value = false;
  }, 1000);
};

/** 选择子账号登录 */
const chooseSubAccountLoginPopup = async () => {
  const res = await getUserLoginSonAccountListApi();
  if (res.status !== "200") return;
  console.log("子账号", res.data);
  selectLoginSonAccountPopupEl.value.show(res.data);
};

/** 倒计时 */
const countdownResetCode = () => {
  countdownResetCodeEl.value = setInterval(() => {
    if (resetCodeTime.value) {
      resetCodeTime.value--;
    } else {
      isGetCodeStatus.value = false;
      resetCodeTime.value = 60;
      clearInterval(countdownResetCodeEl.value);
    }
  }, 1000);
};

/** 获取验证码 */
const handleGetCode = async () => {
  if (!telephone.value) return Message.warning("请先输入手机号");
  if (!checkMobile(telephone.value)) {
    return Message.warning("请输入正确的手机号");
  }
  localStorage.removeItem("token");
  const res = await getUserPhoneCode({
    phone: telephone.value,
    validateSign: hex_md5(telephone.value + "DQ6ODEU9#5!90")
  });
  if (res.status !== "200") return;
  Message.info(res.message || "验证码已发送");
  isGetCodeStatus.value = true;
  countdownResetCode();
};

/** 用户登录 */
const handleUserLogin = async () => {
  if (!telephone.value) return Message.warning("请先输入手机号");
  if (!checkMobile(telephone.value)) {
    return Message.warning("请输入正确的手机号");
  }
  if (!telCode.value) return Message.warning("请输入验证码");
  let tempParams = {};
  if (isBindStatus.value) {
    tempParams = {
      unionId: unionId.value,
      openId: openId.value,
      accessToken: accessToken.value,
      province: province.value,
      city: city.value,
      needBindVX: needBindStatus.value
    };
  }
  const res = await userLoginGetInfo({
    phone: telephone.value,
    code: telCode.value,
    ...tempParams
  });
  if (res.status !== "200") return;
  localStorage.setItem("token", res.data.tokenValue);
  localStorage.setItem("userInfo", JSON.stringify(res.data));
  chooseShopSelectStatus.value = res.data.chooseShop;
  if (chooseShopSelectStatus.value) {
    await chooseSubAccountLoginPopup();
  } else {
    if (redirectUrl.value && defaultLoginType.value === "qrcode") {
      console.log("跳转1", window.location.href);
      window.location.href = removeWeChartUrlParams(
        window.location.href + "home"
      );
    } else {
      await Router.push({
        path: "/home"
      });
    }
  }
  console.log("res", res);
};

/** 登录子账号成功 */
const handleLoginAccountSuccess = async () => {
  window.location.href = removeWeChartUrlParams(
    window.location.href + "home"
  );
};

/** 切换默认登录方式 */
const handleChangeLoginType = (type: "qrcode" | "phone") => {
  if (type === "qrcode") {
    defaultLoginType.value = "phone";
  } else if (type === "phone") {
    qrCodeInit();
    defaultLoginType.value = "qrcode";
  }
};

/** 微信登录 */
const wechatLoginByCode = async (code: string) => {
  const res = await postWechatLoginByCode({ vxCode: code });
  if (res.status !== "200") return;
  if (Number(res.data.status)) {
    localStorage.setItem("token", res.data.tokenValue);
    localStorage.setItem("userInfo", JSON.stringify(res.data));
    chooseShopSelectStatus.value = res.data.chooseShop;
    if (chooseShopSelectStatus.value) {
      // 如果有子账号，则跳转到子账号选择页面
      await chooseSubAccountLoginPopup();
    } else {
      console.log("跳转3", window.location.href);
      window.location.href = removeWeChartUrlParams(
        window.location.href + "home"
      );
    }
  } else {
    isBindStatus.value = true;
    openId.value = res.data.openId;
    unionId.value = res.data.unionId;
    accessToken.value = res.data.accessToken;
    province.value = res.data.province;
    city.value = res.data.city;
    needBindStatus.value = "1";
  }
};

/** 初始化 */
onMounted(async () => {
  try {
    const code = getUrlParams("code");
    const state = getUrlParams("state");
    if (state && code) {
      await wechatLoginByCode(code);
    } else {
      if (defaultLoginType.value === "qrcode") {
        await qrCodeInit();
      }
    }
  } catch (e) {
    console.log(e, "获取错误");
  }
});

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_spin, {
            tip: "Loading...",
            spinning: spinningStatus.value
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["spinning"])
        ]),
        _createElementVNode("div", {
          class: "reset-qrcode",
          onClick: qrCodeInit
        }, "重新获取二维码"),
        _createElementVNode("div", {
          class: "switch-login-type",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleChangeLoginType('qrcode')))
        }, " 使用手机号登录 ")
      ], 512), [
        [_vShow, defaultLoginType.value === 'qrcode' && !isBindStatus.value]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(isBindStatus.value ? "绑定手机号" : "验证码登录"), 1),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            class: "tel-input",
            type: "tel",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((telephone).value = $event)),
            placeholder: "请输入手机号"
          }, null, 512), [
            [_vModelText, telephone.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            class: "code-input",
            type: "tel",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((telCode).value = $event)),
            maxlength: "4",
            placeholder: "输入短信验证码"
          }, null, 512), [
            [_vModelText, telCode.value]
          ]),
          (!_unref(isGetCodeStatus))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["code-btn", telephone.value ? 'active-code-btn' : '']),
                onClick: handleGetCode
              }, " 获取短信验证码 ", 2))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, "重新获取" + _toDisplayString(resetCodeTime.value) + "s", 1))
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["login-btn", telCode.value ? 'active-btn' : '']),
          onClick: handleUserLogin
        }, _toDisplayString(isBindStatus.value ? "绑定" : "登录"), 3),
        _createElementVNode("div", {
          class: "switch-login-type",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (handleChangeLoginType('phone')))
        }, " 使用微信二维码登录 ")
      ], 512), [
        [_vShow, 
        (defaultLoginType.value === 'phone' && !isBindStatus.value) ||
        (defaultLoginType.value === 'qrcode' && isBindStatus.value)
      ]
      ])
    ]),
    _createVNode(SelectLoginSonAccountPopup, {
      ref_key: "selectLoginSonAccountPopupEl",
      ref: selectLoginSonAccountPopupEl,
      onLoginSonAccountSuccess: handleLoginAccountSuccess
    }, null, 512)
  ], 64))
}
}

})